import { createContext } from 'react';

import { type TransactionService } from 'services';
import type { ICsprCloudProxy } from '@make-software/csprclick-core-types';

export interface ServicesContextType {
  transactionService: TransactionService;
  getCsprCloudProxy: () => ICsprCloudProxy | null;
  isClickLoaded: boolean;
}

export const ServicesContext = createContext<ServicesContextType | null>(null);
